<div>
  <p *ngIf="title" class="authentication__right__card_title">
    {{ title | translate }}
  </p>

  <p class="authentication__right__card_description">
    {{ description || 'LOGIN.PASSWORD_RESET.CHANGE_DESCRIPTION' | translate }}
  </p>

  <form [formGroup]="resetPasswordForm">
    <div
      class="authentication__right__card__field mt-27"
      fxLayout="column"
      fxLayoutAlign="center stretch"
      fxLayoutGap="8px"
    >
      <label class="authentication__right__card__field-label">
        {{ 'LOGIN.PASSWORD_RESET.FORM.NEW_PASSWORD' | translate }}
      </label>
      <div class="authentication__right__card__field__input-box">
        <input
          class="authentication__right__card__field__input-box_input"
          [type]="showNewPassword ? 'text' : 'password'"
          autocomplete="new-password"
          name="new-password"
          id="new-password"
          formControlName="password"
          [placeholder]="'LOGIN.AUTH.PLACEHOLDER' | translate"
        />
        <button
          class="authentication__right__card__field__input-box_suffix"
          mat-icon-button
          type="button"
          (click)="showNewPassword = !showNewPassword; $event.stopPropagation()"
          [matTooltip]="(showNewPassword ? 'LOGIN.AUTH.PASSWORD.HIDE' : 'LOGIN.AUTH.PASSWORD.SHOW') | translate"
          [matTooltipPosition]="'below'"
        >
          <mat-icon> {{ showNewPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
      </div>

      <div *ngIf="resetPasswordForm.get('password').touched && resetPasswordForm.get('password').invalid">
        <small
          class="authentication__right__card__field-error"
          *ngIf="resetPasswordForm.get('password').hasError('required')"
        >
          {{ 'LOGIN.PASSWORD_RESET.FORM.ERRORS.REQUIRED' | translate }}
        </small>
        <small
          class="authentication__right__card__field-error"
          *ngIf="resetPasswordForm.get('password').hasError('usedBefore')"
        >
          {{ 'LOGIN.PASSWORD_RESET.FORM.ERRORS.USED_BEFORE' | translate }}
        </small>
        <small
          class="authentication__right__card__field-error"
          *ngIf="
            resetPasswordForm.get('password').hasError('pattern') ||
            resetPasswordForm.get('password').hasError('minlength')
          "
        >
          {{ 'LOGIN.PASSWORD_RESET.FORM.ERRORS.INCORRECT_MATCH' | translate }}
        </small>
      </div>
    </div>

    <div
      class="authentication__right__card__field mt-27"
      fxLayout="column"
      fxLayoutAlign="center stretch"
      fxLayoutGap="8px"
    >
      <label class="authentication__right__card__field-label">
        {{ 'LOGIN.PASSWORD_RESET.FORM.CONFIRM_NEW_PASSWORD' | translate }}
      </label>
      <div class="authentication__right__card__field__input-box">
        <input
          class="authentication__right__card__field__input-box_input"
          autocomplete="new-password"
          [type]="showConfirmationPassword ? 'text' : 'password'"
          name="confirm-new-password"
          id="confirm-new-password"
          formControlName="confirmPassword"
          [placeholder]="'LOGIN.AUTH.PLACEHOLDER' | translate"
        />
        <button
          class="authentication__right__card__field__input-box_suffix"
          mat-icon-button
          type="button"
          (click)="showConfirmationPassword = !showConfirmationPassword; $event.stopPropagation()"
          [matTooltip]="
            (showConfirmationPassword ? 'LOGIN.AUTH.PASSWORD.HIDE' : 'LOGIN.AUTH.PASSWORD.SHOW') | translate
          "
          [matTooltipPosition]="'below'"
        >
          <mat-icon>{{ showConfirmationPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
      </div>

      <div *ngIf="resetPasswordForm.get('confirmPassword').touched && resetPasswordForm.get('confirmPassword').invalid">
        <small
          class="authentication__right__card__field-error"
          *ngIf="resetPasswordForm.get('confirmPassword').hasError('doesNotMatchPassword')"
        >
          {{ 'LOGIN.PASSWORD_RESET.FORM.ERRORS.INCORRECT_CONFIRM' | translate }}
        </small>
      </div>
    </div>

    <p class="authentication__right__card__field-error mt-10" *ngIf="resetPasswordForm.hasError('limitExceeded')">
      {{ 'LOGIN.PASSWORD_RESET.ERRORS.LIMIT_EXCEEDED' | translate }}
    </p>

    <p class="authentication__right__card__field-error mt-10" *ngIf="resetPasswordForm.hasError('unknown')">
      {{ 'LOGIN.PASSWORD_RESET.ERRORS.UNKNOWN_ERROR' | translate }}
    </p>

    <div class="new-password-step__matches">
      <div
        *ngFor="let match of passwordMatches"
        class="new-password-step__matches_item"
        fxLayout="row"
        fxLayoutAlign="start center"
      >
        <mat-icon
          [ngClass]="{
            'new-password-step__matches_item--checked': matchValue(match.regex, resetPasswordForm.get('password').value)
          }"
        >
          done
        </mat-icon>
        <p>{{ 'LOGIN.PASSWORD_RESET.FORM.MATCHES.' + match.translate | translate }}</p>
      </div>
    </div>

    <button
      class="authentication__right__card_next"
      mat-raised-button
      [disabled]="disabled"
      (click)="resetPassword.next()"
    >
      {{ 'LOGIN.PASSWORD_RESET.FORM.SUBMIT' | translate }}
    </button>
  </form>
</div>
